"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.355 4.75h4.146v2.073H3.355zm0 4.146h7.953v2.063H3.355zm0 4.135h12.437v2.073H3.355zm0 4.146h17.291v2.073H3.355z"
}), 'SortAsc');
//# sourceMappingURL=index.js.map